module.exports = __webpack_public_path__ + "img/svg/stream-stats.423fd67c22649a3b129226998c1979bd.svg";